import React from 'react';

const AdminStatsCard = ({ title, value, icon: Icon, color = "indigo" }) => {
  const colorClasses = {
    indigo: "bg-indigo-600",
    green: "bg-green-600", 
    blue: "bg-blue-600",
    purple: "bg-purple-600",
    orange: "bg-orange-600",
    teal: "bg-teal-600",
    pink: "bg-pink-600",
    red: "bg-red-600"
  };

  return (
    <div className="bg-gray-900 rounded-lg p-6 border border-gray-600">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-300">{title}</p>
          <p className="text-2xl font-bold text-white">{value}</p>
        </div>
        <div className={`p-2 ${colorClasses[color]} rounded-lg`}>
          <Icon className="h-6 w-6 text-white" />
        </div>
      </div>
    </div>
  );
};

export default AdminStatsCard;
